module.exports = __webpack_public_path__ + "img/kx-partner-badge-bronze-partner-rgb.4a088df4.svg";